import React from "react";
import { Dialog } from "primereact/dialog";
import { FieldDisplay, ImageCard, VideoCard, ScheduleDisplay } from "@components";
import { GenericDetailsModalProps } from "./types";

export function GenericDetailsModal({
  visible,
  onHide,
  sections,
  header = "Details",
  noDataText = "No data available",
}: GenericDetailsModalProps) {
  return (
    <Dialog
      header={header}
      visible={visible}
      onHide={onHide}
      className="w-full md:w-8 lg:w-5"
      modal
      draggable={false}
    >
      {sections.length > 0 ? (
        sections.map((section, idx) => {
          if (section.type === "image") {
            return (
              <ImageCard
                key={idx}
                imageUrl={section.src || ""}
                altText={section.alt || ""}
                icon={section.icon}
                title={section.title}
              />
            );
          }

          if (section.type === "video") {
            return (
              <VideoCard
                key={idx}
                videoUrl={section.href || ""}
                icon={section.icon}
                title={section.title}
              />
            );
          }

          if (
            section.type === "photos" &&
            section.images &&
            section.images.length > 0
          ) {
            return (
              <div key={idx} className="mb-4">
                <h3 className="mb-3">
                  <i className={`pi ${section.icon} mr-2`}></i>
                  {section.title}
                </h3>

                {section.primaryImage && (
                  <div className="mb-3">
                    <h4 className="text-sm font-semibold mb-2 text-primary">
                      Primary Location Image
                    </h4>
                    <div className="border-round overflow-hidden shadow-2">
                      <img
                        src={section.primaryImage}
                        alt="Primary location"
                        className="w-full"
                        style={{ maxHeight: "300px", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                )}

                {section.images.length > (section.primaryImage ? 1 : 0) && (
                  <div>
                    <h4 className="text-sm font-semibold mb-2 text-primary">
                      Gallery Photos (
                      {section.images.length - (section.primaryImage ? 1 : 0)})
                    </h4>
                    <div className="grid">
                      {section.images
                        .filter((img: any) => !img.isPrimary)
                        .map((img: any, imgIdx: number) => (
                          <div
                            key={imgIdx}
                            className="col-12 md:col-6 lg:col-4"
                          >
                            <div className="border-round overflow-hidden shadow-1">
                              <img
                                src={img.src}
                                alt={img.title}
                                className="w-full"
                                style={{ height: "150px", objectFit: "cover" }}
                              />
                              {img.isFeatured && (
                                <div className="text-center text-xs text-primary mt-1">
                                  <i className="pi pi-star-fill mr-1"></i>
                                  Featured
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            );
          }

          // Special handling for schedule sections
          if (section.hasNewSchedule && section.rawSchedule) {
            return (
              <div key={idx} className="mb-4">
                <h3 className="mb-3">
                  <i className={`pi ${section.icon} mr-2`}></i>
                  {section.title}
                </h3>
                <ScheduleDisplay schedule={section.rawSchedule} showRawData={false} />
              </div>
            );
          }

          return (
            <FieldDisplay
              key={idx}
              title={section.title}
              fields={section.fields || []}
              icon={section.icon}
            />
          );
        })
      ) : (
        <div className="p-4 text-center text-600">{noDataText}</div>
      )}
    </Dialog>
  );
}
